import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Property } from 'src/typings';
import { PropertyService } from '../property.service';

@Component({
  selector: 'app-value-selector',
  templateUrl: './value-selector.component.html',
  styleUrls: ['./value-selector.component.scss']
})
export class ValueSelectorComponent {
  constructor(private propertySrevice: PropertyService) {}

  @Input() set control(control: UntypedFormControl) {
    this._control = control;
    this.control.valueChanges.subscribe((value) => {
      this.filteredValues = this.values.filter((value_) => {
        return value_.toUpperCase().includes(value.toUpperCase());
      });
    });
  }

  get control() {
    return this._control;
  }

  private _control: UntypedFormControl = new UntypedFormControl();

  @Input() set property(property: Property | undefined) {
    this._property = property;
    this.getValues();
  }

  get property() {
    return this._property;
  }

  private _property: Property | undefined;

  values: string[] = [];

  filteredValues: string[] = [];

  getValues() {
    if (!this.property || !this.property.id) return;
    this.propertySrevice
      .getValuesByPropertyId({
        property_id: this.property.id
      })
      .subscribe((list) => {
        this.values = list.map((row) => row.value);
        this.filteredValues = list.map((row) => row.value);
      });
  }
}
